module.exports = __webpack_public_path__ + "static/img/103351.a7512031.png";